import { PureComponent, ReactNode } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { ThunkDispatch } from 'redux-thunk';
import round from 'lodash/round';
import { MobileNumberData, OtpData } from '../store/reducers/login';
import { GlobalState } from '../store/reducers';
import {
    sendOtp,
    VerifyNumberAction,
    verifyOtpAction,
    resendOtp,
    resetNumberError,
    ResetNumberErrorAction,
    resetNumber,
    ResetNumberAction,
    SetMobileNumberAction,
    setMobileNumber,
} from '../store/actions/login';
import { MobileNumberInput, OtpForm, WithLayout } from '../components/mobilenumber';
import { getMobileNumberData, getOtpData } from '../store/selectors/login';
import { GO_TO_SETUP_APP, INIT } from '../routes/paths';
import { resetTracking } from '../tracking';
import { validateEmail } from '../components/mobilenumber/MobileNumberInput';
import fetchMyProfile from '../api/fetchMyProfile';
import { setCurrentActiveId } from '../api/mactiveid';
import { getMyGroupAccessId } from '../store/localstorage';

type State = {
    otp: string;
    resendCountDown: number;
};

interface Props extends RouteComponentProps {
    dispatch: ThunkDispatch<
        GlobalState,
        null,
        VerifyNumberAction | ResetNumberErrorAction | ResetNumberAction | SetMobileNumberAction
    >;
    mobileNumber: MobileNumberData;
    otp: OtpData;
}

export const validateMobileNumber = (mobileNumber: string): boolean => {
    return mobileNumber.trim().length === 10 && /^\d+$/.test(mobileNumber.trim());
};

export const onSuccess = (docId?: string): void => {
    if (!docId) {
        console.error("Didn't got docId");
        return;
    }
    try {
        window.location.replace(INIT);
    } catch (e) {
        console.error(e);
    }
};

class Login extends PureComponent<Props, State> {
    state: State = {
        otp: '',
        resendCountDown: 0,
    };

    componentDidMount = (): void => {
        // check if already logged in stetho
        fetchMyProfile(getMyGroupAccessId())
            .then((r) => {
                try {
                    if (!r?.loginmeta?.isvalid) {
                        resetTracking();
                        console.error('id not found');
                        return;
                    }
                    localStorage.setItem('activeId', r.loginmeta.docid || '');
                    setCurrentActiveId(r.user.oid || '');

                    location.replace(GO_TO_SETUP_APP);
                } catch (e) {
                    resetTracking();
                    console.error('fetchMyProfile=> id not found', e);
                }
            })
            .catch((e) => {
                resetTracking();
                console.error('fetchMyProfile=> id not found', e);
            });
    };

    componentDidUpdate(prevProps: Props) {
        if (this.props.otp.otp.nextOtpRequest !== prevProps.otp.otp.nextOtpRequest) {
            const interval = window.setInterval(() => {
                const current = new Date();
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                const diff = (new Date(this.props.otp.otp.nextOtpRequest) - current) / 1000;
                if (diff < 1) {
                    window.clearInterval(interval);
                }
                this.setState({
                    resendCountDown: round(diff),
                });
            }, 1000);
        }
    }

    handleInputChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
        this.props.dispatch(setMobileNumber(target.value));
        const isValid = validateMobileNumber(target.value);
        if (isValid) {
            this.props.dispatch(sendOtp(target.value));
        }

        if (!!this.props.mobileNumber.errorMessage) {
            this.props.dispatch(resetNumberError());
        }
    };

    handleOnSubmit = () => {
        const { mobileNumber } = this.props.mobileNumber;
        if (mobileNumber && (validateMobileNumber(mobileNumber) || validateEmail(mobileNumber))) {
            this.props.dispatch(sendOtp(mobileNumber));
        }
    };

    handleOtpChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            otp: target.value,
        });
    };

    verifyOtp = (otp: string) => {
        //this.props.history.replace('/');

        if (otp) {
            this.props.dispatch(verifyOtpAction(otp, onSuccess));
        }
    };

    resendOtp = () => {
        this.props.dispatch(resendOtp());
    };

    resetNumber = () => {
        this.props.dispatch(resetNumber());
    };

    render(): ReactNode {
        const { mobileNumber, otp } = this.props;
        return (
            <WithLayout
                isRegistered={mobileNumber.isRegistered}
                isError={!!mobileNumber.errorMessage}
            >
                {mobileNumber.isRegistered ? (
                    <OtpForm
                        key="otp-form"
                        mobileNumber={mobileNumber.mobileNumber}
                        otpError={otp.errorMessage}
                        otpLoader={otp.loading}
                        otpVerified={otp.otpVerified}
                        verifyOtp={this.verifyOtp}
                        resendOtp={this.resendOtp}
                        otp={otp.otp}
                        resendCountDown={this.state.resendCountDown}
                        resetNumber={this.resetNumber}
                    />
                ) : (
                    <MobileNumberInput
                        key="mobile-number-input"
                        mobileNumber={mobileNumber.mobileNumber}
                        loading={mobileNumber.loading}
                        numberError={!!mobileNumber.errorMessage}
                        handleOnInputChange={this.handleInputChange}
                        maxTryError={otp.maxTryError}
                        handleOnSubmit={this.handleOnSubmit}
                    />
                )}
            </WithLayout>
        );
    }
}

export default connect((state: GlobalState) => ({
    mobileNumber: getMobileNumberData(state),
    otp: getOtpData(state),
}))(Login);
